var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4583 6.37171V0.083374C8.24992 1.10421 0.083252 9.90379 0.083252 20.5C0.083252 31.0963 8.24992 39.8959 18.4583 40.9167V34.6284C12.3333 33.6484 6.20825 27.6867 6.20825 20.5C6.20825 13.3134 12.3333 7.35171 18.4583 6.37171ZM34.7303 18.4584H40.9166C39.957 8.25004 32.7499 1.04296 22.5416 0.083374V6.37171C28.6666 7.24962 33.8524 12.3334 34.7303 18.4584ZM22.5416 34.6284V40.9167C32.7499 39.9571 39.957 32.75 40.9166 22.5417H34.7303C33.8524 28.6667 28.6666 33.7505 22.5416 34.6284Z",
    fill: "#323232"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.c2ee797964a9dff67675c86d60320d1c.svg";
export { ForwardRef as ReactComponent };